export const SectionCard = ({
  title,
  right,
  children,
  isRetailerMobile = false, // ✅ ADD THIS
}) => (
  <div
    className={`rounded-2xl p-4 flex flex-col h-full transition-all duration-300
      ${
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
          : "bg-white/95 border border-slate-100/80 shadow-sm hover:shadow-md"
      }`}
  >
    {/* HEADER */}
    <div className="flex items-center justify-between mb-3 gap-2">
      
      <h2
        className={`text-sm font-semibold flex items-center gap-2
          ${
            isRetailerMobile
              ? "text-black"
              : "text-slate-700"
          }`}
      >
        <span
          className={`w-1.5 h-1.5 rounded-full
            ${
              isRetailerMobile
                ? "bg-white/70"
                : "bg-blue-500"
            }`}
        />
        {title}
      </h2>

      {right}
    </div>

    {/* CONTENT */}
    <div className="flex-1">{children}</div>
  </div>
);